module.exports = __webpack_public_path__ + "img/location-pink.5cc733a2.svg";